export default "__VITE_ASSET__BpyHKLYk__"